module.exports = __webpack_public_path__ + "static/media/nasa.1d61dce5.svg";